import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'dp-nav-footer',
    templateUrl: './nav-footer.component.html',
    styleUrls: ['./nav-footer.component.scss']
})
export class NavFooterComponent {
    public limpaNome = 'https://www.serasa.com.br/limpa-nome-online';
    public infoMenu = [
        {
            title: 'O que você precisa?',
            links: [
                {
                    label: 'Consultar meu CPF',
                    url: 'https://www.serasa.com.br/consultar-meu-cpf'
                },
                {
                    label: 'Pedir empréstimo online',
                    url: 'https://www.serasa.com.br/ecred'
                },
                { label: 'Limpar meu nome', url: this.limpaNome },
                {
                    label: 'Consultar pontuação do score',
                    url: 'https://www.serasa.com.br/score'
                },
                { label: 'Negociar minhas dívidas', url: this.limpaNome },
                {
                    label: 'Monitorar meu CPF',
                    url: 'https://www.serasa.com.br/antifraude'
                },
                {
                    label: 'Falar com a Serasa',
                    url: 'https://www.serasa.com.br/atendimento'
                },
                {
                    label: 'Atualizar meus dados',
                    url: 'https://www.serasa.com.br/outros-servicos/atualizacao_de_cadastro/'
                },
                { label: 'Soluções para empresas', url: 'https://www.serasaexperian.com.br' }
            ]
        },
        {
            title: 'Todos os sites',
            links: [
                {
                    label: 'Serasa eCred',
                    url: 'https://www.serasa.com.br/ecred'
                },
                {
                    label: 'Serasa AntiFraude',
                    url: 'https://www.serasa.com.br/antifraude'
                },
                {
                    label: 'Serasa Score',
                    url: 'https://www.serasa.com.br/score'
                },
                { label: 'Serasa Limpa Nome', url: this.limpaNome },
                {
                    label: 'Serasa Cadastro Positivo',
                    url: 'https://www.serasa.com.br/cadastro-positivo'
                },
                {
                    label: 'Serasa Ensina',
                    url: 'https://www.serasa.com.br/ensina'
                }
            ]
        },
        {
            title: 'Atendimento',
            links: [
                {
                    label: 'Pontos de Atendimento',
                    url: 'https://www.serasa.com.br/sc-atendimento/agencias/'
                },
                {
                    label: 'Telefones',
                    url: 'https://www.serasa.com.br/atendimento/'
                },
                {
                    label: 'Central de Ajuda',
                    url: 'https://ajuda.serasa.com.br/hc/pt-br'
                }
            ]
        },
        {
            title: 'Outros serviços',
            links: [
                {
                    label: 'Atualizar meus dados',
                    url: 'https://www.serasa.com.br/outros-servicos/atualizacao_de_cadastro/'
                },
                {
                    label: 'Como consultar seu CPF',
                    url: 'https://www.serasa.com.br/consultar-meu-cpf'
                },
                {
                    label: 'Proteger meus documentos',
                    url: 'https://www.serasa.com.br/documentos-perdidos-roubados'
                },
                {
                    label: 'Carta comunicado',
                    url: 'https://www.serasa.com.br/carta-serasa-experian'
                },
                {
                    label: 'Empresas que consultam meu CPF',
                    url: 'https://www.serasa.com.br/consultas-ao-meu-cpf'
                }
            ]
        }
    ];

    public openMenu(element: any) {
        const list = element.target.nextElementSibling;
        list.classList.toggle('nav-footer__links--open');
    }
}
